import { UseFormReturn } from "react-hook-form";
import { Form } from "@themes/pollinator/ui/Form";
import { FormField } from "@themes/pollinator/ui/FormField";
import { ActionButtonsGroup } from "@themes/pollinator/ui/ActionButtonsGroup";
import type { NotificationSettingsFormData } from "@core/features/profile";

export type Props = {
  form: UseFormReturn<NotificationSettingsFormData>;
  isDirty: boolean;
  isValid: boolean;
  isSubmitting: boolean;
  onSubmit: () => void;
  onCancel: () => void;
};

/**
 * Presentational component for notification settings form.
 * Allows users to configure email and text notification preferences.
 */
export function NotificationSettingsForm({
  form,
  isDirty,
  isValid,
  isSubmitting,
  onSubmit,
  onCancel,
}: Props) {
  return (
    <Form form={form} onSubmit={onSubmit}>
      <FormField
        name="isEmailNotificationsEnabled"
        label="Receive System Notifications Via Email"
        component="Checkbox"
        layout="horizontal"
      />
      <FormField
        name="isTextNotificationsEnabled"
        label="Receive System Notifications Via Text"
        component="Checkbox"
        layout="horizontal"
      />
      <ActionButtonsGroup
        primaryButtonText={isSubmitting ? "Saving..." : "Save"}
        onPrimaryClick={onSubmit}
        secondaryButtonText={isDirty ? "Cancel" : undefined}
        onSecondaryClick={isDirty ? onCancel : undefined}
        className="size-max w-fit self-end"
        primaryButtonProps={{
          disabled: !isDirty || isSubmitting,
          visuallyDisabled: isDirty && !isSubmitting && !isValid,
        }}
      />
    </Form>
  );
}

export default NotificationSettingsForm;
